import React, { Component } from 'react';
import { getSubcategorySlug } from 'common/ducks/categories';
import idx from 'idx';

const LAST_PROJECT_ACTIONS = {
  draft: 'created draft',
  open: 'posted project',
  awarded: 'started wrapup',
  completed: 'completed project'
};

export const openChat = () => {
  runCommand("api.openChat");
  document.body.classList.add("with-drift");
}

const runCommand = (command, args) => {
  if (!window.drift) {
    console.log('Drift command:', command);
  } else {
    /* drift didn't get loaded yet - queue for when it does */
    if (!window.drift.api) {
      window.queuedDriftCommands = window.queuedDriftCommands || [];
      window.queuedDriftCommands.push([command, args]);
    } else {
      const parts = command.split('.');
      if (parts[2]) {
        window.drift[parts[0]][parts[1]][parts[2]](args);
      } else if (parts[1]) {
        window.drift[parts[0]][parts[1]](args);
      } else {
        window.drift[parts[0]](args);
      }
    }
  }
};


export default class DriftChat extends Component {
  constructor(props) {
    super(props);

    this.show = this.show.bind(this);
  }

  setUserAttributes() {
    const { user, categories } = this.props;
    const project = user.last_updated_owned_project;
    const subCategorySlug = project? getSubcategorySlug(categories, project.sub_category) : null;

    runCommand("api.setUserAttributes", {
      email: idx(user, _ => _.email),
      last_project_action: project? (LAST_PROJECT_ACTIONS[project.status] || "none") : "none",
      last_project_sub_category: subCategorySlug || "none"
    });
  }

  show() {
    const { shouldShow, bodyClasses, initiallyHidden } = this.props;

    if (shouldShow) {
      this.setUserAttributes();
      runCommand('api.widget.show');
      runCommand('config', { enableCampaigns: true });

      if (!initiallyHidden) {
        document.body.classList.add("with-drift");
      }

      /* add `bodyClasses` to body if provided */
      if (bodyClasses) {
        bodyClasses.split(' ').forEach(cls => document.body.classList.add(cls));
      }
    }
  }

  hide() {
    const { bodyClasses } = this.props;

    runCommand('api.widget.hide');
    runCommand('config', { enableCampaigns: false });

    document.body.classList.remove("with-drift");

    if (bodyClasses) {
      bodyClasses.split(' ').forEach(cls => document.body.classList.remove(cls));
    }
  }

  componentDidMount() {
    this.show();
  }

  componentWillUnmount() {
    this.hide();
  }

  render() {
    return null;
  }
}
